export default __webpack_public_path__ + "static/etereo-logo-9a2e7657397f5dfd0e55904578bcc374.svg";